import date from 'date-and-time';
import Icon, { ICON_CIRCLE_CLOSE } from '~/components/icon/index.js';
import IconButtonClose from '../misc/icon-button-close.js';
import { HeadWrapper, MainTitle, SubTitle } from '../misc/section-head.js';
import ButtonWrapper from '../misc/button-wrapper.js';
import OverlayHeader from '../layout/header/overlay.js';
import ErrorInfoLabel from '~/components/modal/error-info-label.js';

const ConfirmationFailure = ({
	title,
	info,
	confirmButtonText = 'OK',
	onConfirm,
	text,
	onClick,
	hideHeader,
	unset
}) => (
	<div data-at="confirmation-failure" className="modal-view">
		{!hideHeader && (
			<OverlayHeader transparent>
				<div className="page-head__left-side">
					<IconButtonClose className="page-head__close" onClick={onClick} />
				</div>
				<div className="page-head__right-side" />
			</OverlayHeader>
		)}
		<HeadWrapper>
			<Icon type={ICON_CIRCLE_CLOSE} />

			<MainTitle>{title}</MainTitle>
			<SubTitle
				dangerouslySetInnerHTML={{
					__html: text
				}}
			/>
			{info ? <ErrorInfoLabel info={info} updateTime={date.format(new Date(), 'D MMMM YYYY. h:mm A')} /> : null}
		</HeadWrapper>
		<ButtonWrapper transparent unset={unset}>
			<button
				className="btn btn--secondary btn-border-radius btn-failure-confirm--ok"
				onClick={onConfirm}
				data-at="confirmation-failure-confirm-button"
			>
				{confirmButtonText}
			</button>
		</ButtonWrapper>
	</div>
);
export default ConfirmationFailure;
